import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

import './index.css';
// Global accessibility rules (#363), kept out of index.css
import './a11y.css';
import { applySchoolBrand } from './lib/school-brand';
applySchoolBrand();
import { render } from 'react-dom';
import App from './App';

// Pages are lazy-loaded chunks. A tab left open across a deploy asks for chunk
// names that no longer exist, so reload once to pick up the new build. The
// timestamp stops a reload loop if the chunk is genuinely missing: at most one
// automatic reload per 30 seconds, after which the error surfaces normally.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('chunk-reload-at') || 0);
    if (Date.now() - last < 30_000) return;
    sessionStorage.setItem('chunk-reload-at', String(Date.now()));
  } catch {
    return;
  }
  event.preventDefault();
  window.location.reload();
});
render(<App />, document.getElementById('root'));
